import { render, staticRenderFns } from "./PrisonerFeedbackStats.vue?vue&type=template&id=04770cc9&"
import script from "./PrisonerFeedbackStats.vue?vue&type=script&lang=js&"
export * from "./PrisonerFeedbackStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports